import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

//icon imports
import {
  CartFilled,
  CartOutline,
  CouponFilled,
  CouponOutline,
  UserFilled,
  UserOutline,
} from "../constants/iconExports";

export type navlinkType = {
  label: string;
  key: string;
  iconActive: ReactElement;
  iconInactive: ReactElement;
};

const useNavlinks = () => {
  const { t } = useTranslation();

  const navlinkItems: navlinkType[] = [
    {
      label: String(t("My")),
      key: "/profile",
      iconActive: <UserFilled />,
      iconInactive: <UserOutline />,
    },
    {
      label: String(t("Order")),
      key: "/order",
      iconActive: <CartFilled />,
      iconInactive: <CartOutline />,
    },
    {
      label: String(t("Coupon")),
      key: "/coupon",
      iconInactive: <CouponOutline />,
      iconActive: <CouponFilled />,
    },
  ];
  return {
    navlinkItems,
  };
};
export default useNavlinks;
